module.exports = __webpack_public_path__ + "static/media/Melisandre.6b3b9c1f.jpg";